/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteAutomationAttachmentMutationResponse,
  DeleteAutomationAttachmentPathParams,
  DeleteAutomationAttachment403,
  DeleteAutomationAttachment404,
} from '../types/DeleteAutomationAttachment'

function getDeleteAutomationAttachmentUrl({
  automation_pk,
  id,
}: {
  automation_pk: DeleteAutomationAttachmentPathParams['automation_pk']
  id: DeleteAutomationAttachmentPathParams['id']
}) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/automations/${automation_pk}/attachments/${id}/` as const,
  }
  return res
}

/**
 * @description Delete an automation attachment
 * @summary Delete an automation attachment
 * {@link /api/v1/automations/:automation_pk/attachments/:id/}
 */
export async function deleteAutomationAttachment(
  {
    automation_pk,
    id,
  }: {
    automation_pk: DeleteAutomationAttachmentPathParams['automation_pk']
    id: DeleteAutomationAttachmentPathParams['id']
  },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteAutomationAttachmentMutationResponse,
    ResponseErrorConfig<
      DeleteAutomationAttachment403 | DeleteAutomationAttachment404
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteAutomationAttachmentUrl({ automation_pk, id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
